import { BoxOverflow, Stack } from 'styles';
import AknowledgeData from './AknowledgeData';
import Documentation from './Documentation';
import Invoice from './Invoice';
import Notes from './Notes';
import ReviewActions from './ReviewActions';

const ClaimReview = () => {
	return (
		<BoxOverflow
			variant="y"
			sx={{
				mt: '30px',
				pr: '10px',
			}}
		>
			<Stack gap={'40px'}>
				<Invoice />
				<Documentation />
				<AknowledgeData />
				<Notes />
				<ReviewActions />
			</Stack>
		</BoxOverflow>
	);
};

export default ClaimReview;
